// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3DX2d","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1Ptfj"};